var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"products-table-header"},[_c('BaseText',{staticClass:"table-header-text"},[_vm._v("Produtos da carteira")]),_c('BaseText',{staticClass:"table-header-text"},[_vm._v("Investimento Mínimo")]),_c('BaseText',{staticClass:"table-header-text"},[_vm._v("Valor a Investir")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }